import { Routes } from '@angular/router';
import { PRIVATE_ROUTES } from '@private/private.routes';
import { ValidateOtpGuard } from '@utils/guards/validate-otp.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'priv',
    children: PRIVATE_ROUTES,
    canActivate: [ValidateOtpGuard],
  },
  {
    path: '',
    loadChildren: () => import('@public/public.module')
      .then(m => m.PublicModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
